<cgp-app-card
   [titleText]="resourced ? ' *** Re-sourced TPRs Displayed (Read Only) *** ': (inactive ?  'View Inactive TPRs' : 'View/Update TPRs')"
   showFullScreenToggle="true" [showBackButton]="true" backButtonTooltip="Close"
   [onBackButtonClicked]="onBackButtonClicked.bind(this)">
   <div class="full-height">
      <div class="table-holder half-height">
         <data-table #toolsGrid [data]="tools" [columns]="columns" [loading]="loading" *ngIf="spans"
            [totalRecords]="total" (lazyLoad)="onLazyLoad($event)" [lazy]="true" [paging]="true"
            [pageSize]="pageOptions.size" (select)="onGridSelectionChange($event)" (edit)="editField($event)"
            [showAllPaging]="false" [loading]="loading" trackByField="toolId" [filterColumnDisplay]="false">
            <ng-container actionStart featurePermission="tpr">
               <button mat-button [disabled]="this.resourced" (click)="onDuplicateClick()"
                  *ngIf="(!resourced && !inactive)" subFeaturePermission="duplicate">Duplicate</button>
               <mat-divider *ngIf="!resourced && !inactive" vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button (click)="onDuplicateRevClick()" subFeaturePermission="duplicate"
                  *ngIf="(!this.selectedTpr?.revisionTpr || resourced) && !inactive">Duplicate
                  (Rev)</button>
               <mat-divider *ngIf="(!this.selectedTpr?.revisionTpr || resourced) && !inactive" vertical
                  class="action-bar-vertical-divider"></mat-divider>
               <button mat-button (click)="onAddNewTprClick()" *ngIf="!resourced  && !inactive"
                  subFeaturePermission="tprTool">
                  Add New TPR</button>
               <mat-divider *ngIf="!resourced  && !inactive" vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button *ngIf="!inactive" (click)="onDeleteTprClick()" subFeaturePermission="tool">Delete
                  TPR</button>
               <mat-divider *ngIf="!inactive" vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button *ngIf="!inactive" (click)="onShowCommentsClick()" subFeaturePermission="comment">Show
                  Comments</button>
               <mat-divider *ngIf="!inactive" vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button *ngIf="!inactive" (click)="onReasonCodesClick()" subFeaturePermission="reasons">Reason
                  Codes</button>
               <mat-divider *ngIf="!inactive" vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button (click)="onShowFilesClick()" subFeaturePermission="file"
                  *ngIf="(!this.selectedTpr?.revisionTpr || resourced) && !inactive">Show
                  Files</button>
               <mat-divider *ngIf="(!this.selectedTpr?.revisionTpr || resourced) && !inactive" vertical
                  class="action-bar-vertical-divider"></mat-divider>
               <button *ngIf="!inactive" mat-button (click)="onPrintTprClick()" subFeaturePermission="print">Print
                  TPR</button>
               <mat-divider *ngIf="!inactive" vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button (click)="onNecClick()" subFeaturePermission="nec"
                  *ngIf="(!this.selectedTpr?.revisionTpr || resourced) && !inactive">NEC</button>
               <mat-divider *ngIf="resourced" vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button (click)="onUndoResourceClick()" subFeaturePermission="tool" *ngIf="resourced">Undo
                  Re-source</button>
               <button mat-button *ngIf="inactive" (click)="onActiveTprClick()">
                  Mark TPR Active
               </button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <div style="height: 36px;">
                  <mat-form-field class="spacerLeft">
                     <input #searchBar id="search-fixture-id" type="text" matInput
                        (keydown.enter)="searchFixtureNumber(searchBar)" [(ngModel)]="searchBarInput"
                        placeholder="  Search Fixture Number" />
                     <span *ngIf="searchBarInput" style="margin-left:-20px;">
                        <a (click)="clearSearch()">
                           <i class="fa fa-times" style="color: rgb(149, 149, 153); cursor: pointer;"></i>
                        </a>
                     </span>
                     <button mat-icon-button matSuffix (click)="searchFixtureNumber(searchBar)"
                        (keydown.enter)="searchFixtureNumber(searchBar)">
                        <mat-icon matSuffix>search</mat-icon>
                     </button>
                  </mat-form-field>
               </div>
            </ng-container>
            <ng-container actionEnd>
               <button mat-button (keydown.enter)="onBackButtonClicked()" (click)="onBackButtonClicked()"> Close
               </button>
            </ng-container>
         </data-table>
      </div>

      <mat-tab-group class="half-height" [@.disabled]="true" id="tprTabGroup">
         <mat-tab label="General Info">
            <tpr-general-info [lists]="generalInfoLists" [selectedTpr]="selectedTpr" [reSourced]="this.resourced"
               [inActive]="this.inactive" (updateEvent)="updateSelectedTpr($event)"></tpr-general-info>
         </mat-tab>
         <mat-tab label="Process Kit &amp; Design Status">
            <tpr-process-kit [selectedTpr]="selectedTpr" [reSourced]="this.resourced" [inActive]="this.inactive"
               (updateEvent)="updateSelectedTpr($event)"></tpr-process-kit>
         </mat-tab>
         <mat-tab label="Design Progress">
            <tpr-design-progress [selectedTpr]="selectedTpr" [reSourced]="this.resourced" [inActive]="this.inactive"
               (updateEvent)="updateSelectedTpr($event)">
            </tpr-design-progress>
         </mat-tab>
         <mat-tab label=" Build Progress">
            <tpr-build-progress [selectedTpr]="selectedTpr" [reSourced]="this.resourced" [inActive]="this.inactive"
               (updateEvent)="updateSelectedTpr($event)">
            </tpr-build-progress>
         </mat-tab>
         <mat-tab label="Summary">
            <tpr-summary [lists]="generalInfoLists" [selectedTpr]="selectedTpr" [reSourced]="this.resourced"
               [inActive]="this.inactive" (updateEvent)="updateSelectedTpr($event)"></tpr-summary>
         </mat-tab>
      </mat-tab-group>
   </div>

   <ng-template *ngIf="this.tools?.length === 0">
      <div class="spinner-container">
         <mat-spinner class="standard-spinner"></mat-spinner>
      </div>
   </ng-template>
</cgp-app-card>
<router-outlet></router-outlet>